angular.module('elogbooksDirectives').directive('userRole', ['apiClient', function(apiClient){
    return {
        // Restrict to attributes only.
        restrict: 'A',
        require: ['ngModel'],
        scope: {
            role: '=ngModel'
        },
        templateUrl: '/modules/directives/form-elements/user-role/user-role.html',
        link: function (scope) {
            apiClient.get('/roles').then(function (response) {
                scope.roles = response.getData().roles;
            });
        }
    }
}]);
